(function ($) {
    $(document).ready(function () {
        if ($(".col-three-image").length > 0) {
            $(".col-three-image .column-wrapper p").dotdotdot({
                height: 96,
                fallbackToLetter: true,
                watch: true,
            });
        }

        $(".research-grid .column-wrapper .four-col .small-card-wrapper .small-card-content h6").dotdotdot({
            height: 88,
            fallbackToLetter: true,
            watch: true,
        });

        $(".research-grid .column-wrapper .eight-col .card-wrapper .card-content h3").dotdotdot({
            height: 160,
            fallbackToLetter: true,
            watch: true,
        });

        $(".resource-grid .col-two .inner-wrapper p").dotdotdot({
            height: 100,
            fallbackToLetter: true,
            watch: true,
        });
    });
    
    $(window).on('load', function () {
        if ($(".col-three-image").length > 0) {
            $.each($(".col-three-image .col-three"), function () {
                var bg_Img = $(this).find('.bg-img').clone();
                var content = $(this).find('.content-wrapper').clone();
                var hooverContent = $(this).find(".hover-content");
                hooverContent.empty();
                hooverContent.append(bg_Img);
                hooverContent.append(content);
            });
        }

    });
})(jQuery);
